/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'

import {
  SvgIcon,
  Button
} from '../../'

import {
  AddressPropertyIndicator
} from './AddressPropertyIndicator'

const getAddressTypeLabel = (addressType) => (
  {
    'msisdn': 'Cellphone',
    'landline': 'Landline',
    'email': 'Email',
    'physical': 'Physical'
  }[addressType]
)

const ArchivedAddresses = ({ identityAddresses, onRestoreAddressClick }) => {
  let archivedCellphoneNumbers = identityAddresses.edges.filter(({ node: address }) => (
    address.addressType === 'MSISDN' && address.inactive
  ))
  let archivedLandlinePhoneNumbers = identityAddresses.edges.filter(({ node: address }) => (
    address.addressType === 'LANDLINE' && address.inactive
  ))
  let archivedEmailAddresses = identityAddresses.edges.filter(({ node: address }) => (
    address.addressType === 'EMAIL' && address.inactive
  ))
  let archivedPhysicalAddresses = identityAddresses.edges.filter(({ node: address }) => (
    address.addressType === 'PHYSICAL' && address.inactive
  ))

  if (archivedCellphoneNumbers.length === 0 &&
    archivedLandlinePhoneNumbers.length === 0 &&
    archivedEmailAddresses.length === 0 &&
    archivedPhysicalAddresses.length === 0) {
    return (
      <tbody>
        <tr>
          <td>
            No archived addresses.
          </td>
        </tr>
      </tbody>
    )
  } else {
    return (
      <tbody>
        {archivedLandlinePhoneNumbers.map(({ node: address }) => (
          <ArchivedAddressRow
            address={address}
            onClick={onRestoreAddressClick}
            key={`archivedPhoneNumber_${address.id}`}
          />
        ))}
        {archivedCellphoneNumbers.map(({ node: address }) => (
          <ArchivedAddressRow
            address={address}
            onClick={onRestoreAddressClick}
            key={`archivedLandlinePhoneNumber_${address.id}`}
          />
        ))}
        {archivedEmailAddresses.map(({ node: address }) => (
          <ArchivedAddressRow
            address={address}
            onClick={onRestoreAddressClick}
            key={`archivedEmailAddress_${address.id}`}
          />
        ))}
        {archivedPhysicalAddresses.map(({ node: address }) => (
          <ArchivedAddressRow
            address={address}
            onClick={onRestoreAddressClick}
            key={`archivedPhysicalAddress_${address.id}`}
          />
        ))}
      </tbody>
    )
  }
}

const ArchivedAddressRow = ({ address, onClick }) => (
  <tr>
    <th className='slds-size_1-of-4 slds-cell-wrap slds-text-heading_label'>
      {getAddressTypeLabel(address.addressType.toLowerCase())}
    </th>
    <td>
      <div className='slds-grid'>
        <div>
          {address.addressValue}
        </div>
        <div className='slds-col_bump-left'>
          {!address.optedOut &&
            <AddressPropertyIndicator>
              Opted in
            </AddressPropertyIndicator>
          }
        </div>
        <RestoreButton
          addressId={address.id}
          onClick={onClick}
        />
      </div>
    </td>
  </tr>
)

const RestoreButton = ({ addressId, onClick }) => (
  <Button className='slds-m-left_medium' onClick={() => onClick(addressId)}>
    <SvgIcon
      variant='utility'
      symbol='undelete'
      size='x-small'
      className='slds-m-right_x-small'
    />
    Restore
  </Button>
)

export default ArchivedAddresses



// WEBPACK FOOTER //
// ./src/components/messageplus/employee-contact-details/ArchivedAddresses.js